import { PostgrestSingleResponse } from "@supabase/supabase-js";
import { getSelectedCategoriesArr } from "../assets/data";
import { supabase } from "../../lib/supabase/client";

// projects services

// CRUD
export const addProject = async (submittedData: any) => {
	let res: PostgrestSingleResponse<any[]> = await supabase
		.from("projects")
		.insert([submittedData])
		.select();

	return res;
};
export const updateProject = async (submittedData: any, id?: string) => {
	let idOfDataToUpdate: string | undefined = id;

	let res: PostgrestSingleResponse<any[]>;

	if (!id) {
		// const fetchPersonalDetailsRes = await fetchWorkExperiences();
		// idOfDataToUpdate = fetchPersonalDetailsRes?.data?.[0].id;
		res = await addProject(submittedData);
	} else {
		res = await supabase
			.from("projects")
			.update(submittedData)
			.eq("id", idOfDataToUpdate)
			.select();
	}

	return res;
};

export const fetchProject = async (id: string) => {
	let res: PostgrestSingleResponse<any[]> = await supabase
		.from("projects")
		.select(
			`      
               *,  
               employers ( id, name ),
			   clients ( id, name ),
			   experiences ( * )
            `
		)
		.eq("id", id)
		.order("is_ongoing", { ascending: false })
		.order("start_date", { ascending: false })
		.order("end_date", { ascending: false, nullsFirst: false });

	return res;
};
export const fetchProjects = async (id?: string) => {
	let projectsRes: PostgrestSingleResponse<any[]>;

	if (id) {
		// const fetchPersonalDetailsRes = await fetchWorkExperiences();
		// idOfDataToUpdate = fetchPersonalDetailsRes?.data?.[0].id;
		projectsRes = await fetchProject(id);
	} else {
		projectsRes = await supabase
			.from("projects")
			.select(
				`      
               *,  
               software_owner_details:software_owners ( id, name ),
               employer_details:employers ( id, name ),
               project_owner_details:project_owners ( id, name ),
			   experiences ( * )
            `
			)
			.order("is_ongoing", { ascending: false })
			.order("start_date", { ascending: false })
			.order("end_date", { ascending: false, nullsFirst: false });
	}
	//    tech_stack ( id, name, categories ),
	//    source_categories_details:source_categories ( id, name ),
	//    services_categories_details:services_categories ( id, name ),

	let toolsRes: PostgrestSingleResponse<any[]> = await supabase
		.from("tools")
		.select(`*`);

	// Map tools into a dictionary for quick lookup
	const toolsById = toolsRes?.data?.reduce((acc, tool) => {
		acc[tool.id] = tool;
		return acc;
	}, {});
	// console.log(toolsById);

	let skills_details: any = [];
	projectsRes?.data?.map((project: any) => {
		// check if soft skills is an empty array or not
		if (project?.soft_skills.length > 0) {
			let skillObj = { name: "", category: ["Soft Skills"] };
			project?.soft_skills.forEach((skill: string) => {
				skillObj.name = skill;
			});
			skills_details.push(skillObj);
		} else if (project?.technical_skills.length > 0) {
			let skillObj = { name: "", category: ["Technical Skills"] };
			project?.technical_skills.forEach((skill: string) => {
				skillObj.name = skill;
			});
			skills_details.push(skillObj);
		} else {
			return;
		}
	});

	// Replace tool IDs in tech_stack with tool details
	const projectsWithTools = projectsRes?.data?.map((project: any) => ({
		...project,

		gh_visibility: project?.gh_visibility == "private",

		// ongoing_work: project?.end_date == null,

		associated_experience_details: project?.experiences
			? {
					...project?.experiences,
					employer_details: project?.employers,
			  }
			: {},

		source_categories_details: getSelectedCategoriesArr({
			from: "project source",
			projectCategoryFromDB: project?.source_categories,
		}),

		product_built_categories_details: getSelectedCategoriesArr({
			from: "product built",
			projectCategoryFromDB: project?.product_built_categories,
		}),
		product_categories_details: getSelectedCategoriesArr({
			from: "product built",
			projectCategoryFromDB: project?.product_built_categories,
		}),

		services_categories_details: getSelectedCategoriesArr({
			from: "roles played in project",
			projectCategoryFromDB: project?.services_categories,
		}),

		tech_stack_details: project.tech_stack.map(
			(toolId: any) => toolsById[toolId]
		),
		// tech_stack_details_display: getSelectedSkillsOptionDisplayStructure(
		// 	project.tech_stack.map((toolId: any) => toolsById[toolId])
		// ),

		skills_details,
		skills_details_display: {
			"Technical Skills": project?.technical_skills,
			"Soft Skills": project?.soft_skills,
		},
	}));

	let res = {
		data: projectsWithTools,
		error: projectsRes?.error,
	};

	return res;
};

export const deleteProject = async (id: string) => {
	let res: PostgrestSingleResponse<any[]> = await supabase
		.from("projects")
		.delete()
		.eq("id", id)
		.select();

	return res;
};

// CRUD
export const addTool = async (submittedData: any) => {
	let res: PostgrestSingleResponse<any[]> = await supabase
		.from("tools")
		.insert([submittedData])
		.select();

	return res;
};
export const updateTool = async (submittedData: any, id?: string) => {
	let idOfDataToUpdate: string | undefined = id;

	if (!id) {
		const fetchPersonalDetailsRes = await fetchTools();
		idOfDataToUpdate = fetchPersonalDetailsRes?.data?.[0].id;
	}

	let res: PostgrestSingleResponse<any[]> = await supabase
		// cSession?.access_token
		.from("tools")
		.update(submittedData)
		.eq("id", idOfDataToUpdate)
		.select();

	return res;
};
export const fetchTools = async () => {
	let res: PostgrestSingleResponse<any[]> = await supabase
		.from("tools")
		.select();

	return res;
};
export const fetchTool = async (id: string) => {
	let res: PostgrestSingleResponse<any[]> = await supabase
		.from("tools")
		.select()
		.eq("id", id);

	return res;
};
export const deleteTool = async (id: string) => {
	let res: PostgrestSingleResponse<any[]> = await supabase
		.from("tools")
		.delete()
		.eq("id", id)
		.select();

	return res;
};

const profileProjectServices = {
	// Project,
	updateProject,
	fetchProjects,
	deleteProject,

	// Tool,
	addTool,
	updateTool,
	fetchTools,
	fetchTool,
	deleteTool,
};

export default profileProjectServices;
